import { render, staticRenderFns } from "./ExtFields.vue?vue&type=template&id=2afc4dc8&scoped=true&"
import script from "./ExtFields.vue?vue&type=script&lang=js&"
export * from "./ExtFields.vue?vue&type=script&lang=js&"
import style0 from "./ExtFields.vue?vue&type=style&index=0&id=2afc4dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc4dc8",
  null
  
)

export default component.exports